import { render, staticRenderFns } from "./EnquiryFollowupElement.vue?vue&type=template&id=524a5896"
import script from "./EnquiryFollowupElement.vue?vue&type=script&lang=js"
export * from "./EnquiryFollowupElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports